var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MenuItemList from '../../MenuItemList';
import ProductList from '../ProductList';
function OurMeals(_a) {
    var content = _a.content;
    var meals = content.meals, topSellers = content.topSellers;
    return (_jsxs("div", __assign({ className: "flex justify-start h-full w-full gap-7" }, { children: [_jsx("div", __assign({ className: "w-[364px] flex-[0_0_auto]" }, { children: _jsx(MenuItemList, { title: "Meals", menuItems: meals, maxHeight: "200px", columnWidth: "145px" }) })), _jsx(ProductList, { title: "Top Sellers", products: topSellers, viewAllUrl: "/meals" })] })));
}
export default OurMeals;
